/* 2026-07-23: move the add-to-cart icon out of the floating wishlist cluster
   (top-right, over the image) and into the title row below the image, matching
   the oh polly card layout (wishlist stays on the image, cart icon sits next to
   the product title). Pure DOM relocation (appendChild) rather than a liquid
   template edit - product-item.liquid is a huge, heavily-conditional shared
   snippet used everywhere on the site, and this preserves the button's existing
   click handlers/attributes exactly as-is instead of risking a rewrite.
   MutationObserver covers swiper's loop-mode slide clones and any future
   dynamically-loaded product grids, not just the initial page load. */
(function () {
  function relocate(card) {
    if (card.dataset.dvCartMoved) return;
    var cartBtn = card.querySelector(".product__add-cart");
    var infoBlock = card.querySelector(".product-item__information");
    if (!cartBtn || !infoBlock) return;
    cartBtn.classList.add("dv-cart-in-title");
    infoBlock.insertBefore(cartBtn, infoBlock.firstChild);
    card.dataset.dvCartMoved = "1";
  }

  function scan(root) {
    (root || document).querySelectorAll(".product-item__inner").forEach(relocate);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { scan(); });
  } else {
    scan();
  }
  window.addEventListener("load", function () { scan(); });

  var mo = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (node.matches && node.matches(".product-item__inner")) relocate(node);
        else if (node.querySelectorAll) scan(node);
      }
    }
  });
  mo.observe(document.body, { childList: true, subtree: true });
})();
